

const dapURL =
  'https://cdn.walkme.com/users/b8b2d0e22e77414887218bcd63d03d01/test/walkme_b8b2d0e22e77414887218bcd63d03d01_https.js';

const config = {
  port: process.env.REACT_APP_PORT || 3037,
  clientId: process.env.REACT_APP_AUTH0_ID || '',
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  domain: process.env.REACT_APP_AUTH0_DOMAIN || '',
  ssoEnabled: process.env.REACT_APP_SSO_ENABLED || 'true',
  onestop1URL: process.env.REACT_APP_ONESTOP_1_URL || '',
  onestop2URL: process.env.REACT_APP_ONESTOP_2_URL || '',
  onestop1CookieDomain: process.env.REACT_APP_ONESTOP_1_COOKIE_DOMAIN || '',
  SSOLogoutCookieName: process.env.REACT_APP_SSO_LOGOUT_COOKIE_NAME || 'sso-logged-out',
  internalHelpLink: process.env.REACT_APP_INTERNAL_HELP_LINK,
  externalHelpLink: process.env.REACT_APP_EXTERNAL_HELP_LINK,
  dapWalkMeURL: process.env.REACT_APP_DAP_WALKME_URL || dapURL,
  dapWalkMeExemptUsers: process.env.REACT_APP_DAP_WALKME_EXEMPT_USERS || 'none1',
  dapWalkeMeEnabled: process.env.REACT_APP_DAP_ENABLED || 'true',
};

export default config;
export const port = config.port;